/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminProductListFilter,
    AdminProductListFilterFromJSON,
    AdminProductListFilterFromJSONTyped,
    AdminProductListFilterToJSON,
} from './AdminProductListFilter';

/**
 * 
 * @export
 * @interface AdminDownloadListImages
 */
export interface AdminDownloadListImages {
    /**
     * 
     * @type {boolean}
     * @memberof AdminDownloadListImages
     */
    all?: boolean;
    /**
     * 
     * @type {AdminProductListFilter}
     * @memberof AdminDownloadListImages
     */
    filters?: AdminProductListFilter;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminDownloadListImages
     */
    ids?: Array<string>;
}

export function AdminDownloadListImagesFromJSON(json: any): AdminDownloadListImages {
    return AdminDownloadListImagesFromJSONTyped(json, false);
}

export function AdminDownloadListImagesFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminDownloadListImages {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'all': !exists(json, 'all') ? undefined : json['all'],
        'filters': !exists(json, 'filters') ? undefined : AdminProductListFilterFromJSON(json['filters']),
        'ids': !exists(json, 'ids') ? undefined : json['ids'],
    };
}

export function AdminDownloadListImagesToJSON(value?: AdminDownloadListImages | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'all': value.all,
        'filters': AdminProductListFilterToJSON(value.filters),
        'ids': value.ids,
    };
}

